import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

/** CardActions ships an 8px `margin-left` on every child but the first, which would outrank the
 * `margin-left: auto` used to right-align the primary group. `disableSpacing` + `gap` avoids that. */
export const cardActionsStyled = {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
};

export const PrimaryActions = styled(Box)(() => ({
  alignItems: 'center',
  display: 'inline-flex',
  gap: '8px',
  marginLeft: 'auto',
}));
